import { Type } from "./types";
import { Unit } from "./units";

export const unitOptions:Partial<Record<Type,Unit[]>>={
	distance: [
		'feet',
		'yard',
		'meter'
	],
	volume: [
		'feet3',
		'yard3',
		'meter3'
	],
	area: [
		'feet2',
		'yard2',
		'meter2',
		'acre',
		'kilometer2'
	],
	density: [
		'poundsPerYard3',
		'kilogramPerMeter3',
		'gramPerCentimeter3',
		'shorttonPerYard3',
		'metrictonPerMeter3',
		'metrictonPerMeter',
		'shorttonPerFeet',
		'meter3PerMeter',
		'yard3PerFeet',
	],
	grade:[
		'degrees',
		'tanPercent',
	],
	powderFactorVolume:[
		'kilogramPerMeter3',
		'poundsPerYard3',
		'meter3PerKilogram',
		'yard3PerPound',
	],
	powderFactorWeight:[
		'kilogramPerMetricton',
		'poundsPerShortton',
		'metricTonPerKilogram',
		'shortTonPerPound',
	],
	angle:[
		'degrees',
	],
	weight:[
		'kilogram',
		'pounds',
	],
};
